import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-e4de0f6c")
const _hoisted_1 = { class: "services" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Service = _resolveComponent("Service")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Service, {
      title: "Front End",
      description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste facere, cupiditate cumque voluptates ratione dolor consectetur at dicta neque rem ipsam odit, quisquam rerum adipisci nesciunt totam doloribus repellat error!"
    }),
    _createVNode(_component_Service, {
      title: "Back End",
      description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste facere, cupiditate cumque voluptates ratione dolor consectetur at dicta neque rem ipsam odit, quisquam rerum adipisci nesciunt totam doloribus repellat error!"
    }),
    _createVNode(_component_Service, {
      title: "Manutenção",
      description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste facere, cupiditate cumque voluptates ratione dolor consectetur at dicta neque rem ipsam odit, quisquam rerum adipisci nesciunt totam doloribus repellat error!"
    })
  ]))
}